import React from 'react'
import Modal from '@molecules/Modal'
import PropTypes from 'prop-types'
import { parseHTML } from '@particles/parseHTML'
import './footer.scss'
const { REACT_APP_MENTIONS, REACT_APP_PUBLIC_URL, REACT_APP_BASE_METATITLE2 } =
	process.env
		? process.env
		: {
				REACT_APP_MENTIONS: '',
				REACT_APP_PUBLIC_URL: '',
				REACT_APP_BASE_METATITLE2: ''
		  }

const Footer = ({ children, datas }) => {
	const date = new Date()
	return (
		<footer className="o__footer">
			{children && children}
			<div className="inner container-fluid">
				<ul className="nav-footer">
					{datas &&
						datas.length > 0 &&
						datas.map((item, index) => {
							const { title, url } = item
							return (
								<li key={index} className="nav-item">
									<a
										className="nav-link"
										href={`${process.env.REACT_APP_PUBLIC_URL}/${url}`}
										target="_blank"
									>
										{' '}
										{title}{' '}
									</a>{' '}
								</li>
							)
						})}
					<li>
						<Modal
							showNext
							id="modalCredits"
							open="<a href='#' class='nav-link'>Mentions légales</a>"
							content={parseHTML(REACT_APP_MENTIONS)}
						/>
					</li>
					<li className="nav-item copyright">
						<a href="https://elogie-siemp.paris" target="_blank">
							{' '}
							©{date.getFullYear()} {REACT_APP_BASE_METATITLE2}{' '}
						</a>
					</li>
				</ul>
			</div>
		</footer>
	)
}
Footer.propTypes = {
	children: PropTypes.string,
	datas: PropTypes.arrayOf(PropTypes.object)
}

Footer.defaultProps = {}
export default Footer
